import { Link } from 'react-router-dom';

import { BackButton } from '@/components/stashstr/BackButton';

export default function Rewards() {
  return (
    <div className="prose-sm max-w-none text-[14px] text-gray-800 dark:text-gray-200 space-y-4">
      <BackButton />
      <h1 className="text-[18px] font-bold text-gray-900 dark:text-gray-100">rewards</h1>

      <section className="space-y-2">
        <h2 className="text-[15px] font-semibold">How tipping works</h2>
        <p>
          <strong>Lightning (countable):</strong> if a user has a lightning address, you can zap
          their posts. Zap totals are public receipts on Nostr (NIP-57) and count toward ranking.
        </p>
        <p>
          <strong>Other coins (private):</strong> users can list any crypto address — Monero,
          Bitcoin, Nano, Zcash and more (NIP-A3 payto). These tips are <em>not</em> publicly
          countable. Click an address to copy it, or use the QR button for a QR code.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-[15px] font-semibold">Anti-spam: proof of work</h2>
        <p>
          Posts require <strong>21-bit</strong> PoW, comments <strong>20-bit</strong>,
          up/downvotes and poll votes <strong>18-bit</strong>. Higher bits mean more
          mining time as spam deterrence. Your browser mines a nonce before publishing.
          Unproven content without valid PoW is hidden by default; you can reveal it
          with the “Hide unproven” toggle.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-[15px] font-semibold">Add your own addresses</h2>
        <p>
          Visit{' '}
          <Link to="/settings/payments" className="text-[#1a56db] dark:text-[#6ea8fe] hover:underline">
            payment addresses
          </Link>{' '}
          to publish as many tipping addresses as you want. Lightning addresses enable zaps;
          everything else is copy/QR.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-[15px] font-semibold">For developers</h2>
        <p>
          The full event schema is documented in the project&apos;s{' '}
          <a href="/NIP.md" className="text-[#1a56db] dark:text-[#6ea8fe] hover:underline">
            NIP.md
          </a>
          .
        </p>
      </section>
    </div>
  );
}
